import { API_BASE, getAccessToken } from "@/lib/api/session";
import { platform } from "@/lib/capacitor/platform";
import { t } from "@/i18n";

export async function registerPushDevice(token: string): Promise<boolean> {
 const access = await getAccessToken();
 if (!access) return false;

 const mapped =
 platform === "ios" ? "ios" : platform === "android" ? "android" : "web";

 try {
 const res = await fetch(`${API_BASE}/api/v1/push/devices`, {
 method: "POST",
 headers: {
 Authorization: `Bearer ${access}`,
 "Content-Type": "application/json",
 },
 body: JSON.stringify({
 platform: mapped,
 token,
 appVersion: "0.0.1",
 }),
 });
 return res.ok;
 } catch {
 return false;
 }
}

/**
 * Web placeholder until native push plugins are added.
 * Registers a deterministic dev token so the pipeline can be tested.
 */
export async function registerDevPushIfPossible(): Promise<void> {
 if (typeof window === "undefined") return;
 if (!("Notification" in window)) return;

 // Only attempt when already granted - never spam permission prompts in beta
 if (Notification.permission !== "granted") return;

 const token = `web-dev-${crypto.randomUUID()}`;
 await registerPushDevice(token);
}

/** Ask API to enqueue next Monday weekly-summary reminder. */
export async function scheduleWeeklyReminder(
  hourLocal = 9
): Promise<{ ok: true; scheduledFor?: string } | { ok: false; message: string }> {
  const access = await getAccessToken();
  if (!access) {
    return { ok: false, message: t("errors.scheduleLogin") };
  }
  try {
    const res = await fetch(`${API_BASE}/api/v1/jobs/me/weekly-reminder`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${access}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ hourLocal }),
    });
    const json = (await res.json().catch(() => ({}))) as {
      message?: string;
      job?: { scheduled_for?: string };
    };
    if (!res.ok) {
      return {
        ok: false,
        message: json.message ?? t("errors.scheduleFail"),
      };
    }
    const scheduledFor = json.job?.scheduled_for;
    return scheduledFor
      ? { ok: true, scheduledFor }
      : { ok: true };
  } catch {
    return { ok: false, message: t("errors.apiFail") };
  }
}
